<template>
  <default-layout>
    <template v-if="authTrainer">
      <h1 class="title is-h1">
        Welcome, {{ authTrainer.name }}
      </h1>
      <template v-if="!authTrainer.stripeConnectCode">
        <p>Please take a minute to setup your bank account with Stripe, so we can pay you when you earn money on Fit!:</p>
        <a :href="stripeConnectUrl" class="button is-primary">Connect to Stripe</a>
      </template>
      <template v-else>
        <p>
          <i class="fa fa-check"></i> You have successfully linked your Stripe Connect account.
        </p>
        <p>
          We will be updating this dashboard soon, so you can better track your progress on Fit!
        </p>
      </template>
    </template>
  </default-layout>
</template>

<script>
import DefaultLayout from '../layouts/DefaultLayout.vue'
import { authTrainerQuery } from '../graphql/auth'
import { stripeConnectUrlQuery } from '../graphql/trainers'

export default {
  components: {
    DefaultLayout
  },
  apollo: {
    authTrainer: {
      query: authTrainerQuery
    },
    stripeConnectUrl: {
      query: stripeConnectUrlQuery,
      skip () {
        return !this.authTrainer
      }
    }
  }
}
</script>

<style scoped>
  p {
    margin-bottom: 1em;
  }
</style>
